<template>
  <div class="p-12">
    <div class="max-w-7xl mx-auto space-y-16">
      <div class="flex items-center">
        <h4 class="text-indigo-500">Sales Orders</h4>

        <div class="ml-auto">
          <BaseButton type="button" info @click="handleClickFilter">
            {{ filtersOpen ? 'Hide' : 'Show' }} Filters
          </BaseButton>
        </div>
      </div>

      <div v-show="filtersOpen" class="pb-8">
        <SalesOrderFilters />
      </div>

      <BaseAdvancedList searchable :loading="loading" :entities="salesOrders" :meta="meta">
        <template #header>
          <SalesOrdersHeaderLine />
        </template>

        <template #default="listProps">
          <SalesOrdersLine :sales-order="listProps.entity" />
        </template>
      </BaseAdvancedList>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';
import SalesOrdersHeaderLine from '@/components/SalesOrders/SalesOrdersHeaderLine.vue';
import SalesOrdersLine from '@/components/SalesOrders/SalesOrdersLine.vue';
import SalesOrderFilters from '@/components/SalesOrders/SalesOrderFilters.vue';

export default {
  name: 'OrderIndex',
  components: {
    SalesOrderFilters,
    SalesOrdersHeaderLine,
    SalesOrdersLine,
  },
  data: () => ({
    loading: false,
    filtersOpen: false,
  }),

  computed: {
    ...mapState('ui/salesOrders', ['meta']),
    ...mapGetters('ui/salesOrders', ['salesOrders']),
  },

  watch: {
    $route: 'fetchData',
  },

  created() {
    this.init();
  },

  destroyed() {
    this.setIds([]);
    this.setMeta(null);
    this.setLinks(null);
  },

  methods: {
    ...mapActions('ui/salesOrders', {
      loadSalesOrders: 'load',
    }),
    ...mapMutations('ui/salesOrders', ['setIds', 'setMeta', 'setLinks']),

    async init() {
      try {
        await this.fetchData();
      } catch (error) {
        /** handle error */
      }
    },

    async fetchData() {
      const { query } = this.$route;
      this.loading = true;
      try {
        await this.loadSalesOrders({ params: { ...query, include: ['projectsCount'] } });
      } catch (error) {
        //
      }
      this.loading = false;
    },
    setFiltersOpen(open) {
      this.filtersOpen = open;
    },
    handleClickFilter() {
      this.setFiltersOpen(!this.filtersOpen);
    },
  },
};
</script>
